require("../sass/style.scss");
require("../fonts/fontello/css/fontello.css");
require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/fslightbox");
require("./vendor/cursor");
require("./template_parts/header.es6");
require("./vendor/card-anim");
require("./vendor/animations");

(function ($) {
  $(".main__slider--wrapper").length > 0 && require("./template_parts/slider.es6");
  $(".work").length > 0 && require("./template_parts/work.es6");
  $(".preloader").length > 0 && require("./template_parts/preloader.es6");
  $(".wpcf7-form-control-wrap").length > 0 && require("./template_parts/contact.es6");
  ($(".project-details").length > 0 || $(".single-work-page").length > 0) && require("./template_parts/details.es6");
})(jQuery);



